import React from "react";
import {
  Box,
  TextField,
  Grid,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
  Checkbox,
  Link,
  Button,
} from "@mui/material";
import { StepContent } from "../../styles/StyledComponents";

const Step1DatiPersonali = ({ formData, handleInputChange, onReset }) => {
  return (
    <StepContent>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="outlined"
          onClick={onReset}
          size="small"
        >
          Reset Campi
        </Button>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            label="Nome"
            value={formData.nome}
            onChange={handleInputChange("nome")}
            placeholder="Mario"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            label="Cognome"
            value={formData.cognome}
            onChange={handleInputChange("cognome")}
            placeholder="Rossi"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            type="date"
            label="Data di Nascita"
            value={formData.dataNascita}
            onChange={handleInputChange("dataNascita")}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              placeholder: "gg/mm/aaaa",
              max: new Date(
                new Date().setFullYear(new Date().getFullYear() - 18),
              )
                .toISOString()
                .split("T")[0],
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControl fullWidth required>
              <RadioGroup
                row
                value={formData.sesso}
                onChange={handleInputChange("sesso")}
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  m: 0,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: "text.secondary", mr: 1 }}
                >
                  Sesso *
                </Typography>
                <FormControlLabel
                  value="Maschio"
                  control={
                    <Radio
                      sx={{
                        color: "#ff9800",
                        "&.Mui-checked": { color: "#ff6f00" },
                      }}
                    />
                  }
                  label="Maschio"
                  sx={{ m: 0 }}
                />
                <FormControlLabel
                  value="Femmina"
                  control={
                    <Radio
                      sx={{
                        color: "#ff9800",
                        "&.Mui-checked": { color: "#ff6f00" },
                      }}
                    />
                  }
                  label="Femmina"
                  sx={{ m: 0 }}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            type="email"
            label="Email"
            value={formData.email}
            onChange={handleInputChange("email")}
            placeholder="mario.rossi@email.com"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="Telefono"
            value={formData.telefono}
            onChange={handleInputChange("telefono")}
            placeholder="+39 3123456789"
          />
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === "light" ? "#f5f5f5" : "#2a2a2a",
              padding: 2,
              borderRadius: 1,
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.privacyAccepted}
                  onChange={handleInputChange("privacyAccepted")}
                  sx={{
                    color: "#ff9800",
                    "&.Mui-checked": { color: "#ff6f00" },
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  Ho letto e accetto l'
                  <Link href="#" underline="always" sx={{ fontWeight: 600 }}>
                    informativa sulla privacy
                  </Link>{" "}
                  *
                </Typography>
              }
            />
          </Box>
        </Grid>
      </Grid>
    </StepContent>
  );
};

export default Step1DatiPersonali;
